import { observer } from 'mobx-react';
import useValidationGroup from '../../../../../../../hooks/validation-group/validation-group-hook';
import FedexV2CredentialsStore from '../../../../stores/credentials/shipping/fedex-v2/fedex-v2-credentials-store';
import FedexV2RegistrationEulaModalStep from './modal-steps/fedex-v2-registration-eula-modal-step';
import FedexV2RegistrationAddressModalStep from './modal-steps/fedex-v2-registration-address-modal-step';
import FedexV2RegistrationMfaSelectModalStep from './modal-steps/fedex-v2-registration-mfa-select-modal-step';
import FedexV2RegistrationMfaInputModalStep from './modal-steps/fedex-v2-registration-mfa-input-modal-step';
import FedexV2RegistrationCompleteModalStep from './modal-steps/fedex-v2-registration-complete-modal-step';

interface IProps {
    credentialsStore: FedexV2CredentialsStore;
}

const FedexV2RegistrationModal: React.FC<IProps> = observer(({ credentialsStore }) => {
    const modalVGroup = useValidationGroup();
    const registration = credentialsStore.registration;

    if (!registration) {
        return null;
    }
    const stepProps = { registration, modalVGroup };

    return (
        <>
            {registration.step === 'eula' && (
                <FedexV2RegistrationEulaModalStep {...stepProps} />
            )}
            {registration.step === 'address' && (
                <FedexV2RegistrationAddressModalStep {...stepProps} />
            )}
            {registration.step === 'mfa-select' && (
                <FedexV2RegistrationMfaSelectModalStep {...stepProps} />
            )}
            {registration.step === 'mfa-input' && (
                <FedexV2RegistrationMfaInputModalStep {...stepProps} />
            )}
            {registration.step === 'complete' && (
                <FedexV2RegistrationCompleteModalStep registration={registration} />
            )}
        </>
    );
});

export default FedexV2RegistrationModal;
